import '@hapana/shared/utils/type-defs.util'

/** @type {Styles} */

export const styles = {
  titleSection: {
    flex: 'none',
    paddingX: 4,
  },
  thickDivider: {
    backgroundColor: 'gray.3',
    height: 8,
    border: 0,
    borderTop: (theme) => `1px solid ${theme.palette.gray[8]}`,
  },
  selectsSection: {
    flex: 'initial',
    paddingX: 4,
    paddingY: 1.5,
  },
  editorSection: {
    flex: '1 1 auto',
    paddingX: 4,
    paddingY: 3,
    display: 'flex',
  },
  avatar: {
    width: 20,
    height: 20,
  },
  icon: {
    width: 16,
    height: 16,
    marginRight: 1.5,
    fill: (theme) => theme.palette.gray[56],
  },
  fillSpace: {
    flexGrow: 1,
    '& .MuiOutlinedInput-input': {
      height: '100% !important',
    },
  },
  input: {
    alignItems: 'flex-start',
  },
}
